import script from "./FraudPolicyEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FraudPolicyEditor.vue?vue&type=script&setup=true&lang=js"

import "./FraudPolicyEditor.vue?vue&type=style&index=0&id=12b26588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b26588"]])

export default __exports__